import React from 'react';
import ClaimDocument from './claimDocument';
import ClaimDocumentListFiltersForm from '../claimDocumentListFiltersForm/claimDocumentListFiltersForm';
// @ts-ignore
import { Pager, Loader } from 'arag-ui-lib';
type Props = {
    claimDocument: any[];
    clickDownloadButton: (
        id: string | any,
        fullFileName: string | undefined,
        type: string,
    ) => Promise<any> | any;
    pager: {
        limit: number;
        totalCount: number | null;
        totalPages: number | null;
        page: number;
    };
    goAtPage: () => void;
    goAtStart: () => void;
    goAtEnd: () => void;
    goAtNext: () => void;
    goAtPrevious: () => void;
    handleFormSubmit: (formValues: any) => any;
    handleFormReset: (formikResetForm: () => void) => any;
    claimDocumentLoader: boolean;
    isLoadingDownload: string | null;
    progressFileDownload: any;
    isDisabled: boolean;
};
const ClaimDocumentList = (props: Props): JSX.Element => {
    const {
        claimDocument,
        clickDownloadButton,
        pager,
        goAtPage,
        goAtStart,
        goAtEnd,
        goAtNext,
        goAtPrevious,
        handleFormSubmit,
        handleFormReset,
        claimDocumentLoader,
        isLoadingDownload,
        progressFileDownload,
        isDisabled,
    } = props;

    return (
        <div>
            <ClaimDocumentListFiltersForm
                handleFormReset={handleFormReset}
                handleFormSubmit={handleFormSubmit}
            />
            <div>
                {claimDocumentLoader ? (
                    <div className={'row'}>
                        <div className={'col-sm-offset-3'}>
                            <Loader />
                        </div>
                    </div>
                ) : (
                    claimDocument.map((listItem: { id: string }) => (
                        <ClaimDocument
                            {...listItem}
                            key={listItem.id}
                            clickDownloadButton={clickDownloadButton}
                            isLoadingDownload={isLoadingDownload}
                            progressFileDownload={progressFileDownload}
                            isDisabled={isDisabled}
                        />
                    ))
                )}
            </div>
            {!claimDocumentLoader &&
                claimDocument &&
                claimDocument.length > 0 && (
                    <div className={'row'}>
                        <div className={'col-sm-12'}>
                            <Pager
                                pageSize={pager.limit}
                                totalItems={pager.totalCount || 0}
                                totalPages={pager.totalPages || 0}
                                page={pager.page}
                                goAtPrevious={goAtPrevious}
                                goAtNext={goAtNext}
                                goAtStart={goAtStart}
                                goAtEnd={goAtEnd}
                                goAtPage={goAtPage}
                            />
                        </div>
                    </div>
                )}
        </div>
    );
};

export default ClaimDocumentList;
